import React, { useState, useEffect, useCallback, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "../styles/data.css"; // Assuming the CSS file is in the same folder
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignInAlt } from "@fortawesome/free-solid-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import All from './Allevents';

function Events() {
  const [departments, setDepartments] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedTable, setSelectedTable] = useState("");
  const [activeDepartment, setActiveDepartment] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [hide, setVisible] = useState(false);

  const navigate = useNavigate(); // Initialize useNavigate hook
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await axios.get(
          "http://localhost:8888/30000/competition/backend/events/code/data.php"
        );
        // Remove duplicate departments based on the `department` field
        const uniqueDepartments = response.data.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.department === item.department)
        );
        setDepartments(uniqueDepartments);
      } catch (error) {
        setError("Failed to fetch departments");
        console.error(error);
      }
    };
    fetchDepartments();
  }, []);

  const saveSelectedTable = async (tableName) => {
    try {
      const response = await axios.post(
        "http://gptkpm.in/backend/events/code/saveSelectedTable.php",
        { table_name: tableName },
        { withCredentials: true }
      );
      return response.data.status === "success";
    } catch (error) {
      console.error("Error saving selected table:", error.message);
      return false;
    }
  };

  const fetchTableData = useCallback(
    async (tableName) => {
      setLoading(true);
      setError("");

      const isTableSaved = await saveSelectedTable(tableName);
      if (!isTableSaved) {
        setError("Failed to save selected table");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          "https://gptkpm.in/backend/events/code/getTableData.php",
          { withCredentials: true }
        );
        if (response.data.status === "success") {
          setTableData(response.data.data);
        } else {
          setError(response.data.message || "Failed to fetch table data");
        }
      } catch (error) {
        setError("Failed to fetch table data");
        console.error(error);
      }

      setLoading(false);
    },
    []
  );

  const handleDepartmentClick = (department) => {
    const tableName = department.table_name;
    setSelectedTable(tableName);
    setActiveDepartment(tableName);
    fetchTableData(tableName);
    setIsVisible(false);
  };

  const getBase64Image = (base64String) => {
    return `data:image/jpeg;base64,${base64String}`;
  };

  const handleImageClick = (item) => {
    setSelectedImage(item);
  };

  const closePopup = () => {
    setSelectedImage(null);
  };

  const filterImagesByDate = () => {
    if (!startDate || !endDate) {
      setError("Please select both start and end dates.");
      return;
    }

    const filteredImages = tableData.filter((item) => {
      const itemDate = new Date(item.date);
      const start = new Date(startDate);
      const end = new Date(endDate);

      return itemDate >= start && itemDate <= end;
    });

    setTableData(filteredImages);
  };

  const toggleDateFilter = () => {
    setShowDateFilter((prev) => !prev);
  };

  const handleLoginClick = () => {
    navigate("/login"); // This will navigate to the login page
  };

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div className="events-container">
      <div className="main-panel">
        <div className="departments-filter-container">
          <div className="departments-login">
            <button onClick={toggleVisibility} className="all">All</button>
            <div className="department-buttons-scroll">
              <div className="department-buttons">
                {departments.map((department) => (
                  <button
                    key={department.table_name}
                    onClick={() => handleDepartmentClick(department)}
                    disabled={loading && selectedTable === department.table_name}
                    className={
                      activeDepartment === department.table_name ? "active" : ""
                    }
                  >
                    {department.department}
                  </button>
                ))}
              </div>
            </div>
            <button className="go-to-login-btn" onClick={handleLoginClick}>
              Login
              <FontAwesomeIcon icon={faSignInAlt} style={{ marginLeft: "8px" }} />
            </button>
          </div>
          <div className="datafilter">
            <h2 className="college">College Events</h2>
            <button className="toggle-filter-btn" onClick={toggleDateFilter}>
              {showDateFilter ? "Hide Date Filter" : "Show Date Filter"}
            </button>
          </div>
          <div className="date-filter-main">
            {showDateFilter && (
              <div className="date-filter">
                <p>Enter start to end</p>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  ref={startDateRef} // Use ref to access this input
                />
                <span> to </span>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  ref={endDateRef} // Use ref to access this input
                />
                <button onClick={filterImagesByDate}>Apply</button>
              </div>
            )}
          </div>
        </div>
        <div style={{ display: isVisible ? 'block' : 'none' }}>
          <All />
        </div>
        <div className="image_data">
          {loading ? (
            <p>Loading...</p>
          ) : tableData.length > 0 ? (
            <div className="image-grid">
              {tableData.map((item) => (
                <div
                  key={item.id}
                  className="image-item"
                  onClick={() => handleImageClick(item)}
                >
                  {item.images ? (
                    <img
                      src={getBase64Image(item.images)}
                      alt={item.title}
                      className="image-thumbnail"
                    />
                  ) : (
                    "No image available"
                  )}
                </div>
              ))}
            </div>
          ) : (
            <p>No data found</p>
          )}
        </div>
      </div>
      <div className="image_data_pop">
        {selectedImage && (
          <div className="popup-overlay">
            <div className="popup-content">
              <button className="close-btn" onClick={closePopup}>
                <FontAwesomeIcon icon={faTimes} size="lg" />
              </button>
              <div className="popup-image">
                <img
                  src={getBase64Image(selectedImage.images)}
                  alt={selectedImage.title}
                  className="popup-image-main"
                />
              </div>
              <div className="popup-details">
                <h3>{selectedImage.title}</h3>
                <p>{selectedImage.description}</p>
                <p>
                  <strong>Date:</strong> {selectedImage.date}
                </p>
                <p>
                  <strong>Department:</strong> {selectedImage.department}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Events;
